module.exports = __webpack_public_path__ + "static/media/pin.52dfb6d9.svg";